// src/menu-items/Pawn.js
import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import SellIcon from "@mui/icons-material/Sell";
import OutboxIcon from "@mui/icons-material/Outbox";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import StoreIcon from "@mui/icons-material/Store";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import { useAuth } from "../hooks/useAuth";
import { hasPermission } from "../utils/permissionUtils";

const LandRoutes = () => {
  const { permissions } = useAuth();

  const generateLandRoutes = () => {
    const landRoutes = [
      /* Dashboard Menu */
      {
        title: "Dashboard",
        items: [
          {
            path: "/pawn/dashboard_land",
            name: "Dashboard",
            icon: <DashboardIcon />,
          },
        ],
      },
      /* หมวดหมู่สินค้า โรงรับจำนำ */
      hasPermission(permissions, [
        "List_Products",
        "Edit_Products",
        "Land",
      ]) && {
        title: "สินค้า",
        items: [
          {
            path: "/land/all_product_land",
            name: "ที่ดินทั้งหมด",
            icon: <MapsHomeWorkIcon />,
          },
          {
            path: "/land/buy_items_land",
            name: "ที่ดินที่ซื้อ",
            icon: <RequestPageIcon />,
          },
          {
            path: "/land/ready_items_land",
            name: "ที่ดินพร้อมขาย",
            icon: <ShoppingCartIcon />,
          },
          {
            path: "/land/borrow_items_land",
            name: "ที่ดินถูกเช่า/หมดสัญญา",
            icon: <SwapHorizontalCircleIcon />,
          },
          {
            path: "/land/overdue_borrow_items_land",
            name: "ที่ดินเกินกำหนดยืม",
            icon: <AccessTimeFilledIcon />,
          },
          {
            path: "/land/sold_items_land",
            name: "ที่ดินขายแล้ว",
            icon: <RemoveShoppingCartIcon />,
          },
          {
            path: "/land/overdue_pawn_items_land",
            name: "ที่ดินหลุดจำนอง",
            icon: <HourglassBottomIcon />,
          },
        ],
      },
      /* หมวดหมู่รายการ โรงรับจำนำ */
      hasPermission(permissions, ["List1", "Edit_List1", "Land"]) && {
        title: "รายการ",
        items: [
          {
            path: "/land/sell_on_consignmen_land",
            name: "รายการขายฝาก",
            icon: <SellIcon />,
          },
          {
            path: "/land/redemption_items_land",
            name: "รายการไถ่ถอน",
            icon: <OutboxIcon />,
          },
          {
            path: "/land/setting_price_land",
            name: "ตั้งค่าราคาขาย",
            icon: <PaidIcon />,
          },
          {
            path: "/land/list_by_customer_land",
            name: "รายการแยกตามชื่อลูกค้า",
            icon: <ContactPageIcon />,
          },
          { path: "/land/bin_land", name: "ถังขยะ", icon: <DeleteIcon /> },
          {
            path: "/land/customer_list_land",
            name: "รายชื่อลูกค้า",
            icon: <PeopleAltIcon />,
          },
        ],
      },
      /* หมวดหมู่รายงาน โรงรับจำนำ */
      hasPermission(permissions, ["List_Report", "Edit_Report", "Land"]) && {
        title: "รายงาน",
        items: [
          {
            path: "/land/inventory_land",
            name: "ทรัพย์คงคลัง",
            icon: <StoreIcon />,
          },
          {
            path: "/land/income_expenses_land",
            name: "รายรับ-รายจ่าย",
            icon: <PriceChangeIcon />,
          },
          {
            path: "/land/interest_land",
            name: "ดอกเบี้ย",
            icon: <TrendingUpIcon />,
          },
        ],
      },
      /* หมวดหมู่นำเข้าข้อมูลย้อนหลัง โรงรับจำนำ */
      hasPermission(permissions, ["List_Import", "Edit_Import", "Land"]) && {
        title: "นำเข้าข้อมูลย้อนหลัง",
        items: [
          {
            path: "/land/import_data_land",
            name: "รายการนำเข้า",
            icon: <SummarizeIcon />,
          },
          {
            path: "/land/import_information_land",
            name: "นำเข้าข้อมูลขายฝาก",
            icon: <SellIcon />,
          },
          {
            path: "/land/import_information_buy_land",
            name: "นำเข้าข้อมูลซื้อ",
            icon: <RequestPageIcon />,
          },
          {
            path: "/land/import_list_land",
            name: "นำเข้าข้อมูลรายการ",
            icon: <OutboxIcon />,
          },
        ],
      },
    ].filter(Boolean);

    return landRoutes;
  };

  return generateLandRoutes(); // Call the function to get the routes
};

export default LandRoutes;
